module.exports = __webpack_public_path__ + "img/20190315_111623.f65cd046.jpg";